// extracted by mini-css-extract-plugin
export default {"body":"WeUjV3","buttons":"Np6lst","button":"mLx2Fl","conversion":"A7sVmK","socialButton":"ADdQuX"};